import Route from '@ember/routing/route'

export default class BookingStartRoute extends Route {}
